module.exports = __webpack_public_path__ + "img/logo_footer.3c1c7273.png";